import { t } from "i18next";
import { getShopVatList, resolveTvaFromList } from "../shared";

export function formatZone(dataLivraison: any) {
    if (!dataLivraison || !Array.isArray(dataLivraison)) {
        return [];
    }

    let data: any[] = [];

    dataLivraison.forEach((element: any) => {
        data.push({
            DebutDistance: element.DebutDistance,
            FinDistance: element.FinDistance,
            MinCommande: element.MinCommande,
            FraisLivraison: element.FraisLivraison,
            idTva: Number(element.idTva),
            TauxTva: Number(element.TauxTva),
            detailsZone: `\u001bPG+De ${element.DebutDistance}km à ${element.FinDistance}km \u001bPG-: Frais liv : ${element.FraisLivraison} € \u001bPG- - Min CMD : ${element.MinCommande} €`,
            infoZone: `\u001bPG+De ${element.DebutDistance}km à ${element.FinDistance}km :\u001bPG- (Frais de liv:${element.FraisLivraison} € - Min commande:${element.MinCommande} €)`,
        });
    });

    return data;
}

export const INITIAL_ZONE_FORM_DATA = {
    tva: "",
    shippingCosts: 0,
    minimumAmount: 0,
    remoteDebut: 0,
    endDistance: 0,
    countryData: "",
};

export const INITIAL_VALIDATION = {
    selectCountry: false,
    inputTva: false,
    isNullMinimumAmount: false,
    isOverlap: false,
    isValidationNumber: false,
    isValidationtMinimumAmount: false,
    isDistanceExist: false,
    isDistanceEdited: false,
    isDeliveryNull: false,
};

export function createZoneDetails(
    remoteDebut: number,
    endDistance: number,
    shippingCosts: number,
    minimumAmount: number
) {
    return {
        detailsZone: `\u001bPG+De ${remoteDebut}km à ${endDistance}km \u001bPG-: Frais liv : ${shippingCosts} € \u001bPG- - Min CMD : ${minimumAmount} €`,
        infoZone: `\u001bPG+De ${remoteDebut}km à ${endDistance}km :\u001bPG- (Frais de liv:${shippingCosts} € -Min commande:${minimumAmount}€)`,
    };
}

export function formatZoneLivraisonData(zoneData: any) {
    return (zoneData || []).map((el: any) => ({
        DebutDistance: el.DebutDistance,
        FinDistance: el.FinDistance,
        MinCommande: el.MinCommande,
        FraisLivraison: el.FraisLivraison,
        idTva: el.idTva,
        TauxTva: el.TauxTva,
        detailsZone: el.detailsZone,
        infoZone: el.infoZone,
    }));
}

export function createDataZone(
    localStZoneLivraison: any,
    zoneFormData: any,
    selectedRowShops: any,
    selectedRow: any,
    franchiseID: any,
    isUpdate: boolean
) {
    const tva = resolveTvaFromList(
        zoneFormData.tva,
        getShopVatList(selectedRowShops)
    );
    const zoneDetails = createZoneDetails(
        zoneFormData.remoteDebut,
        zoneFormData.endDistance,
        zoneFormData.shippingCosts,
        zoneFormData.minimumAmount
    );
    const dataZone = {
        DebutDistance: zoneFormData.remoteDebut,
        FinDistance: zoneFormData.endDistance,
        MinCommande: zoneFormData.minimumAmount,
        FraisLivraison: zoneFormData.shippingCosts,
        idTva: tva ? Number(tva.idTva) : 0,
        TauxTva: tva ? Number(tva.tauxTva) : Number(zoneFormData.tva),
        ...zoneDetails,
    };
    if (isUpdate) {
        const index = localStZoneLivraison.findIndex(
            (element: any) =>
                selectedRow[t("remote Debut")] === element.DebutDistance &&
                selectedRow[t("end Distance")] === element.FinDistance
        );
        if (index !== -1) {
            localStZoneLivraison[index] = dataZone;
        }
    } else {
        localStZoneLivraison.push(dataZone);
    }

    localStZoneLivraison = formatZoneLivraisonData(localStZoneLivraison);

    localStZoneLivraison = formatZone(localStZoneLivraison);
    localStZoneLivraison.sort(
        (a: any, b: any) => a.DebutDistance - b.DebutDistance
    );
    const data = {
        shopId: selectedRowShops[0].shopId,
        franchiseID: franchiseID,
        key: "stZoneLivraison",
        data: localStZoneLivraison,
    };
    return data;
}

export function checkOverlap(
    listDistanceZone: any,
    selectedRows: any,
    validation: any,
    zoneFormData: any
) {
    const shouldCheck =
        (selectedRows.length === 0 && validation.isDistanceEdited) ||
        (selectedRows.length > 0 &&
            !(
                zoneFormData.remoteDebut ===
                    selectedRows[0][t("remote Debut")] &&
                zoneFormData.endDistance === selectedRows[0][t("end Distance")]
            ) &&
            validation.isDistanceEdited);
    if (!shouldCheck) return false;

    const zonesToCheck =
        selectedRows.length > 0
            ? listDistanceZone.filter(
                  (el: any) =>
                      !(
                          Number(el.debut) ===
                              Number(selectedRows[0][t("remote Debut")]) &&
                          Number(el.end) ===
                              Number(selectedRows[0][t("end Distance")])
                      )
              )
            : listDistanceZone;

    return zonesToCheck.some(
        (el: any) =>
            (zoneFormData.remoteDebut > el.debut &&
                zoneFormData.remoteDebut < el.end) ||
            (zoneFormData.remoteDebut === el.debut &&
                zoneFormData.endDistance !== 0) ||
            (zoneFormData.remoteDebut < el.debut &&
                zoneFormData.endDistance > el.end) ||
            (zoneFormData.endDistance > el.debut &&
                zoneFormData.endDistance < el.end) ||
            (zoneFormData.remoteDebut < el.end &&
                zoneFormData.endDistance === el.end)
    );
}
